<template>
  <v-row align="center" justify="center">
    <v-col :style="flex" :class="$vuetify.breakpoint.mdAndUp ? 'ml-4 mr-4': ''" >
      <div v-for="(item, index) in items" :key="index">
        <button
            v-if="index !== indexDesabilitado"
            :disabled="!disabledAll"
            :class="index === 0 ? 'button-group buttonFirst' : 'button-group buttonOthers'"
            @click="index == indexStep ? {} : $emit('click', index)"
            :style="index === indexStep ? [activeButton, customStyle] : customStyle"
        >
          <div class="button-inner-flex-container">
            <div class="button-text-block">
              <span class="button-label">{{ typeof item === 'object' ? item.label : item }}</span>
              <div v-if="typeof item === 'object' && item.sublabel" class="subtext">
                {{ item.sublabel }}
              </div>
            </div>
            <icon name="check-circle" :size="20" class="button-icon" />
          </div>
        </button>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    indexStep: {
      type: Number,
      required: true
    },
    disabledAll: {
      type: Boolean,
      required: true
    },
    width: {
      type: [String, Number],
      default: 233
    },
    indexDesabilitado: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    flex () {
      return this.$vuetify.breakpoint.xs
          ? { flex: '0 0 71%' }
          : this.$vuetify.breakpoint.sm
              ? { flex: '0 0 15%' }
              : { flex: '0' }
    }
  },
  data () {
    return {
      activeButton: {
        'background-color': '#00995D',
        color: 'white'
      },
      customStyle: {
        width: this.width + 'px'
      }
    }
  }
}
</script>

<style lang="sass" scoped>
button::focus
  border: 0 !important
  outline: none !important

button::-moz-focus-inner
  border: 0 !important
  outline: none !important

::-moz-focus-inner
  border: 0
  padding: 0

.button-group
  border-radius: 5px
  border: #00995D solid 1px
  background-color: white
  color: #00995D
  width: 100%
  height: 49px
  margin-bottom: 30px
  padding: 0 10px

  display: flex
  justify-content: flex-end
  align-items: center
  box-sizing: border-box

  &:active
    background-color: #00995D
    color: white

.button-inner-flex-container
  display: flex
  align-items: center
  justify-content: flex-end
  width: 100%

.button-text-block
  display: flex
  flex-direction: column
  align-items: flex-end
  flex-grow: 1
  line-height: 1.2

.button-label
  text-align: right

.button-icon
  position: relative
  top: 4px
  margin-left: 5px

.subtext
  font-size: 0.75em
  color: inherit
  font-style: italic
  margin-top: 2px
  line-height: 1.2
  text-align: right

.buttonFirst
  margin-top: 40px
  margin-bottom: 30px

.buttonOthers
  margin-top: 0px
  margin-bottom: 30px

.button-group:active,
.button-group.is-active
  .subtext
    color: rgba(255, 255, 255, 0.8)
</style>